import { Navigate, Route, Routes } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import Login from '@/pages/Login';
import AppLayout from '@/app/AppLayout';
import Admin from '@/pages/prebid/PrebidPage';
import RedirectsPage from '@/pages/RedirectsPage';
import AdsTxtPage from '@/pages/AdsTxtPage';
import ProductsPage from '@/pages/ProductsPage';
import TagsPage from '@/pages/TagsPage';
import ShopsPage from '@/pages/ShopsPage';
import VideoPage from '@/pages/VideoPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
	const me = useQuery({ queryKey: ['me'], queryFn: api.me });
	if (me.isLoading) return <FullPageMessage>Ładowanie…</FullPageMessage>;
	if (me.isError) return <FullPageMessage>Błąd auth: {String(me.error)}</FullPageMessage>;
	if (!me.data?.authenticated) return <Navigate to="/login" replace />;
	return <>{children}</>;
}

function FullPageMessage({ children }: { children: React.ReactNode }) {
	return <div className="flex h-screen items-center justify-center text-muted-foreground">{children}</div>;
}

export default function App() {
	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route
				element={
					<RequireAuth>
						<AppLayout />
					</RequireAuth>
				}
			>
				<Route path="/" element={<Navigate to="/prebid" replace />} />
				<Route path="/prebid" element={<Admin />} />
				<Route path="/prebid/:service" element={<Admin />} />
				<Route path="/prebid/:service/:tab" element={<Admin />} />
				<Route path="/redirects" element={<RedirectsPage />} />
				<Route path="/redirects/:service" element={<RedirectsPage />} />
				<Route path="/adstxt" element={<AdsTxtPage />} />
				<Route path="/adstxt/:service" element={<AdsTxtPage />} />
				<Route path="/feed" element={<ProductsPage />} />
				<Route path="/feed/tags" element={<TagsPage />} />
				<Route path="/feed/moto" element={<ProductsPage moto />} />
				<Route path="/buybox" element={<ShopsPage />} />
				<Route path="/video" element={<VideoPage />} />
				<Route path="/video/:service" element={<VideoPage />} />
			</Route>
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
